import React from 'react';
import Div from '~/components/atom/Div';
import Divider from '~/components/atom/Divider';
import Input from '~/components/molecule/Input';
import TagListInput from '~/components/molecule/TagListInput';
import Validation from '~/util/Validation';
import { TEXT } from '../../constants';
import SectionContainer from '../SectionContainer';
import SectionHeaderWithDescription from '../SectionHeaderWithDescription';
import type {
  UpdateSettingsAction,
  UpdateSettingsState,
} from '../../reducers/settingsReducer';
import type { TouchedFields } from '../../hooks/useSettingsValidation';

type Props = {
  updateSettings: UpdateSettingsState;
  leadScoreErrors: Array<string>;
  tagInputValue: string;
  dispatch: React.Dispatch<UpdateSettingsAction>;
  setTagInputValue: (value: string) => void;
  setFieldTouched: (field: keyof TouchedFields) => void;
};

const RulesSection: React.FCC<Props> = ({
  updateSettings,
  dispatch,
  leadScoreErrors,
  tagInputValue,
  setTagInputValue,
  setFieldTouched,
}) => (
  <SectionContainer direction="row" justification="space-between" gap="base">
    <Div width="100%">
      <SectionHeaderWithDescription
        icon="star"
        header={TEXT.minLeadscoreHeader}
        description={TEXT.minLeadscoreDescription}
      />
      <Input
        type="text"
        value={updateSettings?.rules?.minLeadscore}
        onChange={e => {
          setFieldTouched('leadscore');
          if (!Validation.Number.isNumber(Number(e.target.value))) {
            return;
          }

          dispatch({
            type: 'SET_MIN_LEADSCORE',
            payload: e.target.value,
          });
        }}
        width="100%"
        externalErrors={leadScoreErrors}
        label={{ text: TEXT.numberInputLabel }}
      />
    </Div>
    <Divider margin={[null, 's']} vertical />

    <Div width="100%">
      <SectionHeaderWithDescription
        icon="tag"
        header={TEXT.tagInputHeader}
        description={TEXT.tagInputDescription}
      />
      <Div width="100%">
        <TagListInput
          inputValue={tagInputValue}
          onChange={value => {
            setTagInputValue(value);
          }}
          onAdded={value => dispatch({ type: 'ADD_NOT_TAG', payload: value })}
          onRemoved={value =>
            dispatch({ type: 'REMOVE_NOT_TAG', payload: value })
          }
          selectedValues={updateSettings?.rules?.notTags ?? []}
        />
      </Div>
    </Div>
  </SectionContainer>
);

export default RulesSection;
